export { default } from './PageTeaser';
